<template>
  <div class="mt-3" id="odinIndicadorRealAtoProcessamento">

    <card :loading-full="loading">
      <card-content v-if="!loading">


          <div class="row">

            <template v-if="dataBus.info.digitalizacoesSemOcr > 0">
              <div class="col" v-if="!isTextoImportado">
                <AlertWithAction tipo="danger" label-botao="Executar Leitura OCR" :run="runOcr">
                  Recomendamos realizar o OCR das digitalizações antes de dar continuidade.
                </AlertWithAction>
              </div>
            </template>

            <!-- OCR por PDF (assíncrono, em lote): mostra o andamento real até concluir (COMPLETED)
                 ou falhar (ERROR). Só quando há digitalizações sem OCR — se todas já têm OCR, não há
                 o que acompanhar (nem por que consultar o status). -->
            <div class="col" v-if="!isTextoImportado && dataBus.info.digitalizacoesSemOcr > 0">
              <OdinOcrPdfProgresso ref="ocrPdfProgresso" :ficha-id="indicadorRealId" :livro="livro"
                                   @concluido="load" @removido="load" />
            </div>

            <div class="col" v-if="textoLegado">
              <AlertWithAction tipo="warning" label-botao="Executar Leitura Texto Importado" :run="loadTextoImportado">
                Este indicador possui texto importado de um sistema anterior.
              </AlertWithAction>
            </div>

          </div>


        <template>

          <AlertAtosIA :numeros="atos.map(a => a.numero)"/>

<!--          <div class="text-right mb-2">-->
<!--            <odin-informar-erro :referencia="indicadorRealId" tipo="EXTRAIR_ATOS_MATRICULA" />-->
<!--          </div>-->

          <div class="d-flex">
            <div class="mr-auto">
              <p class="text-muted pb-2 mb-2 small">
                <template v-if="atosSelecionados.length > 0">{{atosSelecionados.length}} ato(s) selecionado(s)</template>
                <template v-else>Nenhum ato selecionado</template>
              </p>
            </div>

            <v-button :run="atualizarMinutas" :button="true" v-if="atosSelecionados.length > 0"
                      :popover="true" position="dropleft" class="btn btn-sm btn-outline-success icon ml-2">
              Atualizar Minutas
            </v-button>

            <v-button :run="cadastrarLote" :button="true" v-if="atosSelecionados.length > 0"
                      :popover="true" position="dropleft" class="btn btn-sm btn-outline-success icon ml-2">
              Cadastrar Selecionados
            </v-button>

            <v-button :run="extrairComIa" :button="true" v-if="!isTextoImportado"
                      :popover="true" position="dropleft" class="btn btn-sm btn-outline-primary icon ml-2">
              Extrair com IA
            </v-button>


          </div>

          <card-table class="table-striped mb-2">
            <thead>
              <tr>
                <th style="width: 40px">
                  <i v-if="atosSelecionados.length > 0" @click="toggleSelectAll(false)"
                     title="Limpar Seleção" class="pointer fa-solid fa-circle-check text-success"></i>
                  <i v-else @click="toggleSelectAll(true)"
                     title="Selecionar Todos" class="pointer fa-solid fa-circle-dashed"></i>
                </th>
                <th style="width: 45px"></th>
                <th style="width: 45px">Origem</th>
                <th style="width: 40px">Número</th>
                <th style="width: 45px">Tipo</th>
                <th class="">Data</th>
                <th class="">Título</th>
                <th></th>
                <th class="" style="width: 70px"></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="ato in atos">
                <tr :key="ato.numero || ato.id">

                  <td class="text-center">

<!--                    <i v-if="ato.ato && ato.ato.validado" class="pointer fa-solid fa-check-circle text-info" title="Ato Já Validado no Sistema"></i>-->

                    <template v-if="!(ato.ato && ato.ato.validado)">
                      <i v-if="ato.selecionado" @click="$set(ato, 'selecionado', false)" class="pointer fa-solid fa-circle-check text-primary"></i>
                      <i v-else @click="$set(ato, 'selecionado', true)" class="pointer fa-solid fa-circle-dashed"></i>
                    </template>

                  </td>

                  <td><i class="fa fa-plus-square pointer float-right mr-2" v-if="!ato.ato" title="Cadastrar ato legado" @click="cadastrarAtoLegado(ato)"></i></td>

                  <td class="lborder text-center text-success" v-if="ato.ato" title="Ato já cadastrado no sistema"><i class="fa-solid fa-database"></i></td>
                  <td class="lborder text-center text-danger" v-else title="Ato não cadastrado no sistema"><i class="fa-solid fa-microchip-ai"></i></td>

                  <td class="text-center">{{ato.numero}}</td>
                    <td class="text-center">{{ato.tipoSigla}}</td>
                    <td>{{$formatters.date(ato.registro)}}</td>
                    <td class="small">{{ato.titulo || '-'}}</td>
                    <td class="small"></td>

                  <td class="lborder">
                    <i v-if="!ato.toggleMinuta" class="fa-solid fa-chevron-down pointer" @click.prevent="toggle('toggleMinuta', ato, true)"></i>
                    <i v-if="ato.toggleMinuta" class="fa-solid fa-chevron-up pointer" @click.prevent="toggle('toggleMinuta', ato, false)"></i>
                  </td>

                </tr>
                <tr v-if="ato.toggleMinuta" :key="(ato.numero || ato.id) + '-minuta'" style="background: transparent">
                  <td colspan="100%">
                    <div class="row gutters-xs">
                      <div class="col-6">
                        <div class="border-sidebar p-2 m-2" style="border: 1pt solid var(--second-color)">
                          <h5>Texto Extraído OCR</h5>
                          <div class="texto-minuta small" v-html="ato.texto" style="width: 500px;"/>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="border-sidebar p-2 m-2" style="border: 1pt solid var(--second-color)">
                          <h5>Texto Cadastrado</h5>
                          <div v-if="ato.ato && ato.ato.texto" class="texto-minuta small" v-html="ato.ato.texto" style="width: 500px;"/>
                        </div>
                      </div>
                      <div class="w-100">
                        <div class="texto-minuta" v-html="ato.replyStr" />
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </card-table>

        </template>
      </card-content>

    </card>

  </div>
</template>

<script>
import FrontBusiness from "@/business/FrontBusiness";
import AtoLegadoBusiness from "@/business/indicadores/AtoLegadoBusiness";
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import CardTable from "@/components/Layout/components/CardTable.vue";
import ModalCadastroAtoLegado from "@/views/Odin/componentes/ModalCadastroAtoLegado.vue";
import AlertWithAction from "@/components/alert/AlertWithAction.vue";
import AlertAtosIA from "@/components/alert/AlertAtosIA.vue";
import OdinOcrPdfProgresso from "@/views/Odin/modais/componentes/OdinOcrPdfProgresso.vue";

export default {
  name: "OdinIndicadorRealOcrProcessamento",
  components: {OdinOcrPdfProgresso, AlertWithAction, AlertAtosIA, CardTable, CardContent, Card},
  props: {
    indicadorRealId: String,
    livro: {
      type: String,
      default: 'MATRICULA'
    },
    textoLegado: Boolean,
    dataBus: {
      type: Object,
      request: true
    }
  },
  data() {
    return {
      loading: true,
      isTextoImportado: false,
      textos: [],
      atos:[],
      ctrl:{
        toggleSelecao:false
      }
    };
  },
  computed:{
    isRegistroAuxiliar(){
      return this.livro === 'REGISTRO_AUXILIAR'
    },
    baseAcompanhamento(){
      return this.isRegistroAuxiliar ? 'acompanhamento-registro-auxiliar' : 'acompanhamento-matriculas'
    },
    baseDigitalizacao(){
      return this.isRegistroAuxiliar ? 'digitalizacoes-registro-auxiliar' : 'digitalizacoes-matricula'
    },
    atosSelecionados(){
      return this.atos?.filter(r => !!r.selecionado)
    },
    atosSemTexto(){
      return this.atos?.filter(r => !r.ato?.possuiTexto)
    },
  },

  async mounted() {
    // O andamento do OCR vem do OdinOcrPdfProgresso (polling de status). O contador da fila legada,
    // que era consultado aqui quando o motor por página existia, saiu com ele.
    await this.load();
  },

  methods:{

    async load(){

      // if(!this.dataBus.info.digitalizacoesSemOcr){

      if (this.isTextoImportado) {
        await this.loadTextoImportado()
        return
      }

      this.$set(this, 'loading', true);

        let atos = await this.$api.get(`api/odin/${this.baseAcompanhamento}/${this.indicadorRealId}/ocr`)
          .catch(e => FrontBusiness.showError('', e.message));

        atos = (atos || [])?.map(a => {
          a.tipoSigla = a.codigo == 0 ? '' : a.tipo == 'AVERBACAO' ? 'AV' : 'R'
          return a;
        })

      this.$set(this, 'atos', atos);

      // }

      this.$set(this, 'loading', false);
    },

    async loadTextoImportado(){
      this.$set(this, 'loading', true);

      let atos = await this.$api.get(`api/odin/${this.baseAcompanhamento}/${this.indicadorRealId}/ocr-texto-importado`)
        .catch(e => FrontBusiness.showError('', e.message));

      atos = atos?.map(a => {
        a.tipoSigla = a.codigo == 0 ? '' : a.tipo == 'AVERBACAO' ? 'AV' : 'R'
        return a;
      })

      this.$set(this, 'atos', atos);
      this.$set(this, 'isTextoImportado', true);
      this.$set(this, 'loading', false);
    },

    toggle(key, ato, valor){
      this.$set(ato, key, valor);
    },

    toggleSelectAll(result){
        this.atos.forEach(ato => {
          if(!(ato.ato && ato.ato.validado)){
            this.$set(ato, 'selecionado', result);
          }
        });
    },

    async cadastrarAtoLegado(ato){
      await FrontBusiness.openModal(ModalCadastroAtoLegado, {ato: ato, ficha: {id: this.indicadorRealId, livro: this.livro}});
      await FrontBusiness.sleep(500);
      await this.load();
    },

    async runOcr(){
      this.$set(this, 'loading', true);

      await this.$api.post(`api/odin/ocr/${this.baseDigitalizacao}/${this.indicadorRealId}`).catch(e => FrontBusiness.showError('', e.message));

      // Reinicia o acompanhamento de status para refletir o processo recém-enfileirado.
      this.$nextTick(() => this.$refs.ocrPdfProgresso?.iniciarPolling());

      await this.load();
    },

    async extrairComIa(){
      let r = await this.$api.post(`api/odin/${this.baseAcompanhamento}/${this.indicadorRealId}/extratificar-ocr`)
        .catch(e => {
          FrontBusiness.showError('', e.message);
          return false;
        });
      if (r){
        FrontBusiness.showSuccess('', 'Extração com IA realizada')
        this.load();
      }
    },

    async atualizarMinutas(){
      for(let pos in this.atosSelecionados) {
        const id = this.atosSelecionados[pos]?.atoId;
        const texto = this.atosSelecionados[pos]?.texto;
        if(id && texto){
          await this.$api.post(`api/ato-legado/${id}/atualizar/minuta`, {value: texto});
          // this.$set(this.atosSelecionados[pos], 'selecionado', false);
        }
      }

      FrontBusiness.showSuccess('', 'Minutas atualizadas');

      this.load();

    },

    showError(e) {
      FrontBusiness.showError('', e.message);
    },

    async cadastrarLote(){
      for(let pos in this.atosSelecionados) {
        const ato = this.atosSelecionados[pos];
        const id = ato?.atoId;
        const texto = ato?.texto;
        if(!id && texto && ato.registro){

          const dto = {
            livro: this.livro,
            codigo: ato.codigo,
            registro: ato.registro+ 'T00:00:00',
            titulo: ato.titulo,
            tipo: ato.tipo,
            texto: texto,
          }
          if(this.isRegistroAuxiliar){
            dto.registroAuxiliar = {id: this.indicadorRealId}
          } else {
            dto.indicadorReal = {id: this.indicadorRealId}
          }
          console.debug(ato, dto)

          await AtoLegadoBusiness.saveByIa(dto).catch(e => FrontBusiness.showError('', e.message));
          //this.$set(this.atosSelecionados[pos], 'selecionado', false);
        }
      }

      FrontBusiness.showSuccess('', 'Atos cadastrados');

      this.load();

    }

  }
};
</script>

<style lang="scss">
#odinIndicadorRealAtoProcessamento{
  th.rborder, td.rborder{
    border-right: 1pt solid gray;
  }
  th.lborder, td.lborder{
    border-left: 2pt solid var(--asgard-input);
  }
}
</style>
